import { type FC } from 'react'

import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { productAccessorSomeVariantHasSaeOffer } from '../../model/productAccessor/ProductAccessorSomeVariantHasSaeOffer'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { ProductPageAddToNotepadButton } from '../ProductPageAddToNotepadButton/ProductPageAddToNotepadButton'
import { useProductPageContext } from '../productPageContext'
import { ProductPagePersonalAdviceButton } from '../ProductPagePersonalAdviceButton/ProductPagePersonalAdviceButton'

import { ProductBuyBoxSocialPopup } from './ProductBuyBoxSocialPopup'

const shouldShowAddToNotepadButton = (
  productTemplate: PRODUCT_TEMPLATES,
  prescriptionType: PrescriptionPrescriptionTypeEnum,
  isPrescriptionProductInChTenant: boolean,
): boolean => {
  const isOtxAndNoPrescription =
    productTemplate === PRODUCT_TEMPLATES.OTX &&
    prescriptionType === PrescriptionPrescriptionTypeEnum.NoPrescription

  const isOtc = productTemplate === PRODUCT_TEMPLATES.OTC

  if (isPrescriptionProductInChTenant) {
    return false
  }

  return isOtc || isOtxAndNoPrescription
}

export const ProductBuyBoxIcons: FC = () => {
  const { currentPrescriptionType, isMasterPage, product, productTemplate } =
    useProductPageContext()
  const { tenant } = useGlobalConfigContext()

  const showPersonalAdvice = productAccessorSomeVariantHasSaeOffer(product)
  const isPrescriptionProductInChTenant =
    productAccessorIsPrescriptionProduct(product) && TENANT.CH === tenant

  if (isMasterPage) {
    return null
  }

  return (
    <ul className="mb-5 tablet:flex tablet:justify-center tablet:gap-5">
      {shouldShowAddToNotepadButton(
        productTemplate,
        currentPrescriptionType,
        isPrescriptionProductInChTenant,
      ) && (
        <li className="border-b border-dark-primary-min py-2.5 last:border-b-0 tablet:border-b-0">
          <ProductPageAddToNotepadButton />
        </li>
      )}
      {productTemplate !== PRODUCT_TEMPLATES.RX &&
        !isPrescriptionProductInChTenant && (
          <li className="border-b border-dark-primary-min py-2.5 last:border-b-0 tablet:border-b-0">
            <ProductBuyBoxSocialPopup />
          </li>
        )}
      {showPersonalAdvice ? (
        <li className="border-b border-dark-primary-min py-2.5 last:border-b-0 tablet:border-b-0">
          <ProductPagePersonalAdviceButton />
        </li>
      ) : null}
    </ul>
  )
}
